export const isNotNull = <T>(value: T | null): value is T => {
  return value !== null;
};
export function isDefined<T>(val: T | undefined): val is T {
  return val !== undefined;
}
